module.exports = __webpack_public_path__ + "static/cta-ae9b32834ef7c0419146f36d80737af7.png";